<template>
  <div class="token token-guide">
    <div class="token-badge-guide">
      <div class="token-icon">
        <img v-if="token.icon" :src="tokenLogo" class="token-image" />
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import EventBus from "../eventBus";
import $ from "jquery";

export default {
  name: "TokenGuide",

  props: {
    token: {
      type: Object,
      default: () => {},
    },

    guidesVisible: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    baseUrl: process.env.BASE_URL,
  }),

  computed: {
    tokenLogo() {
      return this.baseUrl + this.token.icon;
    },
  },

  mounted() {
    this.setPosition();
    EventBus.$on("toggleGuide", () => {
      this.toggleGuide();
    });
  },

  methods: {
    // set position of guide in the coordinate wrapper
    setPosition() {
      const posX = this.token.positionX / 2 + 50;
      const posY = this.token.positionY / 2 + 50;

      gsap.set(this.$el, {
        left: posX + "%",
        top: posY + "%",
      });
    },

    // show hide guides
    toggleGuide() {
      $(this.$el).toggleClass("visible");

      gsap.to(this.$el, {
        duration: 0.4,
        scale: +this.guidesVisible ? 0.1 : 1,
        force3D: true,
        ease: "sine.easeInOut",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.token {
  width: 7.5vw;
  display: inline-block;
  position: relative;
  user-select: none;
}

.token-guide {
  margin: 0;
  position: absolute;
  z-index: 1;
  transform: translateX(-50%) translateY(-50%) scale(0.1);
  pointer-events: none;

  .token-icon {
    position: relative;
    z-index: 1;
    transition: all 1s;
    opacity: 0;
  }

  &:after {
    content: "";
    width: 4vw;
    height: 4vw;
    position: absolute;
    border-radius: 100%;
    top: 50%;
    left: 50%;
    z-index: 0;
    transform: translateX(-50%) translateY(-50%);
    opacity: 1;
    background: $cerulean;
    transition: all 1s;
  }

  &.visible {
    .token-icon {
      opacity: 1;
    }

    &:after {
      background: $cerulean;
      opacity: 0.2;
    }
  }
}

.token-badge-guide {
  width: 4vw;
  height: 3vw;
  border-radius: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.token-icon,
.token-color {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}

.token-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.token-image,
.token-color {
  width: 60%;
  height: 60%;
  object-fit: contain;
}
</style>
